import { Pipe, PipeTransform } from '@angular/core';
import { getVideoThumbnail, getVideoStreamFile } from './media-url.utils';

@Pipe({ name: 'videoThumbnail' })
export class VideoThumbnailPipe implements PipeTransform {
  transform(videoOrId: any, suffix: string = '_thumb.jpg'): string {
    return getVideoThumbnail(videoOrId, suffix);
  }
}

@Pipe({ name: 'videoStreamFile' })
export class VideoStreamFilePipe implements PipeTransform {
  transform(videoOrId: any, suffix: string = '_drm_meta.mpd'): string {
    return getVideoStreamFile(videoOrId, suffix);
  }
}
